exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-mobile__modal-mobile__2I8vt{background:rgba(0,0,0,.8)}.modal-mobile__modal-mobile-window__3pnJo{width:85%;min-width:85%;overflow:visible;border-radius:0;text-align:center}.modal-mobile__modal-mobile-content__1FcRl{padding:0;color:#000}.modal-mobile__fixed-iframe__4ISc3{z-index:9999}", ""]);

// exports
exports.locals = {
	"modal-mobile": "modal-mobile__modal-mobile__2I8vt",
	"modalMobile": "modal-mobile__modal-mobile__2I8vt",
	"modal-mobile-window": "modal-mobile__modal-mobile-window__3pnJo",
	"modalMobileWindow": "modal-mobile__modal-mobile-window__3pnJo",
	"modal-mobile-content": "modal-mobile__modal-mobile-content__1FcRl",
	"modalMobileContent": "modal-mobile__modal-mobile-content__1FcRl",
	"fixed-iframe": "modal-mobile__fixed-iframe__4ISc3",
	"fixedIframe": "modal-mobile__fixed-iframe__4ISc3"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/shared/components/modal/modal-mobile.styl
// module id = 1296
// module chunks = 0 1 2 3